import { automation } from './automation';
import { automationInsights } from './automationInsights';
import { automationProjections } from './automationProjections';
import { create } from './create';
import { createFromTemplate } from './createFromTemplate';
import { deleteEndpoint } from './delete';
import { duplicate } from './duplicate';
import { exportAnnotation } from './exportAnnotation';
import { get } from './get';
import { getAutomationTargets } from './getAutomationTargets';
import { getRelatedObjectsCounts } from './getRelatedObjectsCounts';
import { list } from './list';
import { nextAnnotation } from './nextAnnotation';
import { patch } from './patch';
import { saveAutomationTarget } from './saveAutomationTarget';
import { suggestedRecipients } from './suggestedRecipients';
import { upload } from './upload';

export { queuePatchPayloadSchema } from './patch.schema';

export {
  type CreateQueueFromTemplatePayload,
  type CreateQueueFromTemplateQuery,
} from './createFromTemplate';
export { type AutomationPayload, type AutomationResponse } from './automation';
export { type QueueDuplicatePayload } from './duplicate';
export { type QueueListQuery, type QueueListQueryWithFields } from './list';
export { type QueuePatchPayload } from './patch';
export { type AutomationResponseAutomationBlocker } from '../models/automationResponseAutomationBlocker';

export const queues = {
  list,
  automation,
  delete: deleteEndpoint,
  get,
  patch,
  getRelatedObjectsCounts,
  createFromTemplate,
  create,
  exportAnnotation,
  upload,
  suggestedRecipients,
  duplicate,
  nextAnnotation,
  automationInsights,
  automationProjections,
  saveAutomationTarget,
  getAutomationTargets,
};
